<template>
  <div class="flex relative-position">
    <div
      class="inline-flex full-width dot-container row justify-center absolute"
    >
      <div
        :class="['q-pa-xs', { 'cursor-pointer': isDotClickable(dot) }]"
        v-for="(dot, index) in dots"
        :key="index"
        @click="clickDot(dot)"
      >
        <div
          :class="[
            'dot',
            {
              'stretch-dot': dot.active && stretchActive,
              [`bg-${color}`]: dot.active,
              'bg-grey-4': !dot.active
            }
          ]"
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SAIPageDots',
  props: {
    dots: {
      type: Array,
      default: () => []
    },
    disable: Boolean,
    color: {
      type: String,
      default: 'primary'
    },
    stretchActive: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    clickDot(dot) {
      if (this.isDotClickable(dot)) {
        this.$emit('input', dot);
      }
    },
    isDotClickable(dot) {
      return !this.disable && !dot.disable && !dot.active;
    }
  }
};
</script>

<style lang="sass" scoped>
.dot-container
    margin-top: -6px
    flex-wrap: nowrap

.dot
    width: 6px
    height: 6px
    border-radius: 25px
    flex-shrink: 0

.stretch-dot
  width: 40px
</style>
